export const FETCH_DRAFT_ACCOUNT = "FETCH_DRAFT_ACCOUNT";
export const SET_ACCOUNT_ID = "SET_ACCOUNT_ID";
export const SET_ACCOUNT_COUNTRY = "SET_ACCOUNT_COUNTRY";
export const DELETE_ACCOUNT_ID = "DELETE_ACCOUNT_ID";
export const DELETE_ACCOUNT_COUNTRY = "DELETE_ACCOUNT_COUNTRY";

export const DELETE_DRAFT_ACCOUNT = "DELETE_DRAFT_ACCOUNT";
export const DELETE_DRAFT_ACCOUNT_SUCCESS = "DELETE_DRAFT_ACCOUNT_SUCCESS";
export const DELETE_DRAFT_ACCOUNT_FAILURE = "DELETE_DRAFT_ACCOUNT_FAILURE";
